import React, { useState } from 'react';
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Divider, Grid, Link } from '@mui/material';
import { matchIsValidTel, MuiTelInput } from "mui-tel-input";

export function PhoneNumberSubmissionDialog(props) {
    const {onClose, isOpen} = props;
    const [submitButtonEnabled, setSubmitButtonEnabled] = useState(false);
    const [phone, setPhone] = useState('');

    const handleSubmit = () => {
        onClose(phone.countryCallingCode, phone.nationalNumber);
        console.log(phone)
    };

    const handleSkipPhoneNumber = () => {
        onClose(null, null);
    };

    const handlePhoneNumberChange = (value, info) => {
        setSubmitButtonEnabled(matchIsValidTel(value));
        setPhone(info)
    };

    return (
        <Dialog open={isOpen} data-testid='phoneNumberSubmissionDialog'>
            <DialogTitle>Thanks! Want More?</DialogTitle>
            <Divider/>
            <DialogContent>
                <MuiTelInput
                    variant='outlined'
                    name='phoneNumber'
                    type='phoneNumber'
                    label='Phone Number'
                    fullWidth
                    defaultCountry={'US'}
                    forceCallingCode
                    value={phone.numberValue}
                    onlyCountries={['US', 'CA']}
                    inputProps={{maxLength: 12}}
                    onChange={handlePhoneNumberChange}/>
                <DialogContentText>
                    <br/>
                    By providing my phone number, I consent to receive automated calls and texts regarding important
                    information about my transaction from Hertz. I will not receive automated marketing messages unless
                    I separately consent.&nbsp;
                    <Link
                        href='https://www.hertz.com/rentacar/privacypolicy/index.jsp?targetPage=privacyPolicyView.jsp'
                        data-testid='privacyPolicyLink'
                    >
                        Privacy Policy
                    </Link>
                </DialogContentText>
                <Grid container sx={{paddingTop: '2em'}} direction={'row-reverse'}>
                    <Grid item>
                        <Button
                            onClick={handleSubmit}
                            size='medium'
                            variant='contained'
                            color='secondary'
                            id='phoneNumberSubmit'
                            disabled={!submitButtonEnabled}
                            data-testid='phoneNumberSubmitButton'
                        >
                            Submit
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            onClick={handleSkipPhoneNumber}
                            size='medium'
                            color='primary'
                            id='phoneNumberSkip'
                            data-testid='phoneNumberSkipButton'
                            style={{marginRight: "1em"}}
                        >
                            Skip this step
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}
